<template>
  <div class="base-products">
    <div class="base-products__title">
      <p>Pilih <span class="red">jenis pengiriman</span> sesuai kebutuhan kamu</p>
    </div>
    <div
      v-if="!isLoadingToFetch" 
      class="base-products__slider"
    >
      <Carousel
        :slider-dot-position="setAlignDot"
        :name="carouselName"
        :size="isDesktopWidth ? listChunkItem.length - 2 : listChunkItem.length"
        :total-all-data="products.length"
        color-slider="whiteWithRoundBlackM"
        :shimmer="false"
        :auto-play="true"
        :auto-play-interval="5000"
        :show-dot="isMobileWidth ? true : false"
        :is-absolute="true"
        :scroll-focus="false"
        margin-slider="auto -20px"
      >
        <template #item>
          <div
            v-for="(slide, index) in listChunkItem"
            :id="`${carouselName}-${index+1}`"
            :key="`${index}-key`"
            class="slide-number"
          >
            <router-link
              v-for="(product, j) in slide"
              :id="`id-${carouselName}-${index}-${j}`"
              :key="`key-${index}-${j}`"
              :class="`slide-item class-${carouselName} base-products__slider__card`"
              style="cursor: pointer;"
              :to="goToDetail(product.slug)"
            >
              <div class="base-products__slider__card__top">
                <div
                  v-if="product.service_name.toUpperCase() === 'BOSSPACK'"
                  class="base-products__slider__card__top__content"
                >
                  <img
                    :src="iconPasti"
                    class="base-products__slider__card__top__content__img"
                    alt="mbg.png"
                  >
                  <div class="base-products__slider__card__top__content__text">
                    PASTI (Paket Telat Sehari, Ongkir Diganti)
                  </div>
                </div>
              </div>
              <div class="base-products__slider__card__body">
                <div class="base-products__slider__card__body__top">
                  <img
                    :src="product.root_service_asset"
                    :alt="product.alt_root_service_asset"
                  >
                </div>
                <div class="base-products__slider__card__body__bottom">
                  <div class="base-products__slider__card__body__bottom__text">
                    {{ product.text_estimation }}
                  </div>
                  <img
                    v-if="product.service_name.toUpperCase() === 'BOSSPACK'"
                    :src="iconPasti"
                    class="base-products__slider__card__body__bottom__img"
                    alt="mbg2.png"
                  >
                </div>
              </div>
              <div class="base-products__slider__card__line" />
              <div class="base-products__slider__card__bottom">
                <div class="base-products__slider__card__bottom__text">
                  {{ product.text_service_title }}
                </div>
              </div>
            </router-link>
          </div>
        </template>
      </Carousel>
    </div>
    <div
      v-else
      class="base-products__slider-skeleton"
    >
      <div
        v-for="i in skeletonNumber"
        :key="i"
        class="base-products__slider-skeleton__item shimmer"
      />
    </div>
    <Button
      id="btn_lihat_semua_jenis_pengiriman_new"
      text="Lihat selengkapnya"
      type-class="indigo-dark"
      img="ics_o_arrow_diagonal_white.svg"
      class="base-products__button"
      :round="true"
      :route-to="{ path: '/product' }"
    />
  </div>
</template>

<script>
import Carousel from "@/components/new-carousel/Carousel";
import {
  chunkArray,
  generateChunkCarouselResponsive,
  listenerWindowResize,
  MEDIA,
  removeListenerResize
} from "@/components/new-carousel/util.js";
import ProductUseCase from "../app/usecase/product";
import iconPasti from "@/assets/new-home/ics_o_pasti.svg";
import Button from "@/components/new-button/Button.vue";

export default {
  name: "ProductsSectionHome",
  components: {
    Carousel,
    Button,
  },
  data() {
    return {
      carouselName: 'productsHome',
      isMobileWidth: false,
      isTabletWidth: false,
      isDesktopWidth: false,
      products: [],
      isLoadingFetchData: false,
      iconPasti,
    }
  },
  computed: {
    isLoadingToFetch: function() {
      return this.isLoadingFetchData;
    },
    listChunkItem: function () {
      return chunkArray(this.products, 1)
    },
    setAlignDot() {
      return this.isMobileWidth || this.isTabletWidth ? "start" : "center"
    },
    skeletonNumber() {
      return this.isDesktopWidth ? 3 : 1
    }
  },
  async created() {
    this.isMobile();
    this.isTablet();
    this.isDesktop();
    listenerWindowResize(this.isMobile);
  },
  mounted() {
    this.fetchDataProduct();
  },
  beforeDestroy() {
    removeListenerResize(this.isMobile);
  },
  methods: {
    async fetchDataProduct() {
      this.isLoadingFetchData = true;
      const data = await ProductUseCase.getAll();
      if (data && data.err === null) {
        this.isLoadingFetchData = false;
        this.products = data.data;
      } else {
        this.isLoadingFetchData = false;
      }
    },
    isMobile() {
      this.isMobileWidth = generateChunkCarouselResponsive(window.innerWidth) === MEDIA().MOBILE;
    },
    isTablet() {
      this.isTabletWidth = generateChunkCarouselResponsive(window.innerWidth) === MEDIA().TABLET;
    },
    isDesktop() {
      this.isDesktopWidth = window.innerWidth > 1023;
    },
    goToDetail(slug) {
      return `/product/${slug.toLowerCase()}`
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.base-products {
  margin: auto;
  max-width: 1200px;
  padding: 80px 0;

  @include for-size(mobile) {
    width: 100%;
    padding: 80px 0;
  }

  @include for-size(mobile-landscape) {
    width: 100%;
    padding: 80px 0;
  }

  @media (min-width: 690px) and (max-width: 1023px) {
    width: 60vw;
    padding: 80px 0;
  }

  @media (min-width: 1024px) and (max-width: 1280px) {
    max-width: 900px;
    padding: 80px 0;
  }
  
  &__title {
    display: flex;
    font-size: 48px;
    font-weight: 700;
    line-height: 58px;
    color: $color-indigo-dark;
    margin: 0 0 40px;
    justify-content: center;
    text-align: center;

    .red {
      color: $color-red-5;
    }

    @include for-size(mobile) {
      width: 80%;
      font-size: 24px;
      line-height: 30px;
      margin: 0 auto 32px;
    }

    @media (min-width: 690px) and (max-width: 1023px) {
      font-size: 24px;
      line-height: 30px;
      margin: 60px 0 30px 0;
    }
    
    @media (min-width: 1024px) and (max-width: 1280px) {
      font-size: 30px;
      line-height: 40px;
      margin: 60px 0 30px 0;
    }
  }

  &__slider {
    z-index: 2;

    ::v-deep .slides {
      position: relative;
      scroll-snap-type: unset;
      -webkit-scroll-snap-type: unset;
    }

    @include for-size(mobile) {
      ::v-deep .body-slider {
        margin-bottom: 32px;
      }

      ::v-deep .slides {
        overflow-x: auto;
        -webkit-mask-image: none !important;
        mask-image: none !important;
        margin: unset;
        scroll-snap-type: x mandatory;
        -webkit-scroll-snap-type: x mandatory;

        &::-webkit-scrollbar {
          //width: 0;  /* Remove scrollbar space */
          height: 0;
          background: transparent; /* Optional: just make scrollbar invisible */
        }
        
        > div {
          scroll-snap-align: center;
          -webkit-scroll-snap-align: center;
        }
      }

      ::v-deep .slide-number:first-of-type {
        padding-left: 5%;
      }

      ::v-deep .slide-number:last-of-type {
        padding-right: 5%;
      }

      ::v-deep #slider-dots {
        & > span {
          width: 10px;
          height: 8px;
          background: $color-gray-pensive-5;
          border-radius: 6px;
          margin: 0 0.3rem 0 0;

          &:active {
            top: unset;
          }
        }

        .active-slider {
          width: 32px;
          background-color: $color-indigo-dark !important;
        }
      }
    }

    @include for-size(mobile-landscape) {
      ::v-deep .body-slider {
        margin-bottom: 8px;
      }

      ::v-deep .slides {
        overflow-x: auto;
        -webkit-mask-image: none !important;
        mask-image: none !important;
        margin: unset;
        scroll-snap-type: x mandatory;
        -webkit-scroll-snap-type: x mandatory;

        &::-webkit-scrollbar {
          //width: 0;  /* Remove scrollbar space */
          height: 0;
          background: transparent; /* Optional: just make scrollbar invisible */
        }
        
        > div {
          scroll-snap-align: center;
          -webkit-scroll-snap-align: center;
        }
      }

      ::v-deep .slide-number:first-of-type {
        padding-left: unset;
        margin-left: 5%;
      }

      ::v-deep .slide-number:last-of-type {
        padding-right: unset;
        margin-right: 5%;
      }

      ::v-deep #slider-dots {
        & > span {
          width: 10px;
          height: 8px;
          background: $color-gray-pensive-5;
          border-radius: 6px;
          margin: 0 0.3rem 0 0;

          &:active {
            top: unset;
          }
        }

        .active-slider {
          width: 32px;
          background-color: $color-indigo-dark !important;
        }
      }
    }

    @media (min-width: 690px) and (max-width: 1023px) {
      ::v-deep .body-slider {
        margin-bottom: 8px;
      }

      ::v-deep .slides {
        overflow-x: auto;
        -webkit-mask-image: none !important;
        mask-image: none !important;
        margin: 0;
        scroll-snap-type: x mandatory;
        -webkit-scroll-snap-type: x mandatory;

        &::-webkit-scrollbar {
          //width: 0;  /* Remove scrollbar space */
          height: 0;
          background: transparent; /* Optional: just make scrollbar invisible */
        }
        
        > div {
          scroll-snap-align: center;
          -webkit-scroll-snap-align: center;
        }
      }

      ::v-deep .slide-number:first-of-type {
        padding-left: unset;
      }

      ::v-deep .slide-number:last-of-type {
        padding-right: unset;
      }

      ::v-deep #slider-dots {
        & > span {
          width: 10px;
          height: 8px;
          background: $color-gray-pensive-5;
          border-radius: 6px;
          margin: 0 0.3rem 0 0;

          &:active {
            top: unset;
          }
        }

        .active-slider {
          width: 32px;
          background-color: $color-indigo-dark !important;
        }
      }
    }

    @media (min-width: 1024px) and (max-width: 1280px) {
      ::v-deep .body-slider {
        margin-bottom: 8px;
      }

      ::v-deep .slides {
        overflow-x: auto;
        -webkit-mask-image: none !important;
        mask-image: none !important;
        margin: 0;
        scroll-snap-type: x mandatory;
        -webkit-scroll-snap-type: x mandatory;

        &::-webkit-scrollbar {
          //width: 0;  /* Remove scrollbar space */
          height: 0;
          background: transparent; /* Optional: just make scrollbar invisible */
        }
        
        > div {
          scroll-snap-align: center;
          -webkit-scroll-snap-align: center;
        }
      }

      ::v-deep .slide-number:first-of-type {
        padding-left: unset;
      }

      ::v-deep .slide-number:last-of-type {
        padding-right: unset;
      }

      ::v-deep #slider-dots {
        & > span {
          width: 10px;
          height: 8px;
          background: $color-gray-pensive-5;
          border-radius: 6px;
          margin: 0 0.3rem 0 0;

          &:active {
            top: unset;
          }
        }

        .active-slider {
          width: 32px;
          background-color: $color-indigo-dark !important;
        }
      }
    }
    
    &__card {
      background-color: white;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 380px;
      border: 1px solid #D0D5DD;
      box-shadow: 0px 18px 20px 4px #00000005;
      border-radius: 16px;
      min-height: 350px;
      margin-bottom: 40px;

      @include for-size(mobile) {
        width: 90vw;
        min-width: 320px !important;
      }

      @include for-size(mobile-landscape) {
        width: 70vw;
      }

      @media (min-width: 690px) and (max-width: 1023px) {
        width: 60vw;
      }

      @media (min-width: 1024px) and (max-width: 1280px) {
        width: 280px;
        min-height: 250px;
      }

      &__top {
        min-height: 38px;

        &__content {
          display: flex;
          border-radius: 16px 16px 0 0;
          background-color: #EBECF0;
          align-items: center;
          padding: 11px 16px;

          &__img {
            margin-right: 6px;
            width: 16px;
            height: 16px;
          }

          &__text {
            font-size: 14px;
            line-height: 16px;
            color: $color-base-text;

            @media (min-width: 1024px) and (max-width: 1280px) {
              font-size: 12px;
              line-height: 14px;
            }
          }
        }
      }

      &__body {
        min-height: 210px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 15px;

        @media (min-width: 1024px) and (max-width: 1280px) {
          margin-bottom: 0;
          min-height: 180px;
        }

        &__top {
          max-height: 185px;

          @media (min-width: 1024px) and (max-width: 1280px) {
            max-height: 120px;
          }

          img {
            height: 185px;
            width: 250px;

            @media (min-width: 1024px) and (max-width: 1280px) {
              height: 120px;
              width: 160px;
            }
          }
        }

        &__bottom {
          display: flex;
          justify-content: center;
          align-items: center;
          width: max-content;
          height: max-content;
          max-width: 90%;

          &__text {
            font-size: 14px;
            line-height: 20px;
            background-color: #EBECF0;
            border-radius: 16px;
            padding: 4px 8px;
            color: $color-base-text;
            white-space: nowrap;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;

            @media (min-width: 1024px) and (max-width: 1280px) {
              font-size: 12px;
              line-height: 16px;
            }
          }

          &__img {
            margin-left: 8px;
            width: 24px;
            height: 24px;
          }
        }
      }

      &__line {
        margin: 0 24px 20px;
        border-bottom: 1px dashed $color-border-primary;
      }

      &__bottom {
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        color: $color-indigo-dark;
        min-height: 50px;
        display: flex;
        justify-content: center;
        margin: auto;
        max-width: 90%;

        @media (min-width: 1024px) and (max-width: 1280px) {
          font-size: 14px;
          line-height: 16px;
          min-height: 40px;
        }

        &__text {
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    &__card:hover {
      border: 1px solid $color-indigo-dark;
      transition: all ease-in-out 0.3s;
    }
  }

  &__slider-skeleton {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    &__item {
      width: 380px;
      background-color: $color-gray-pensive-5;
      border: 1px solid $color-border-primary;
      box-shadow: 0px 18px 20px 4px #00000005;
      border-radius: 16px;
      min-height: 350px;
      margin-bottom: 40px;

      @include for-size(mobile) {
        width: 90vw;
        min-width: 320px !important;
      }

      @include for-size(mobile-landscape) {
        width: 70vw;
      }

      @media (min-width: 690px) and (max-width: 1023px) {
        width: 60vw;
      }

      @media (min-width: 1024px) and (max-width: 1280px) {
        width: 280px;
        min-height: 250px;
      }
    }

    .shimmer {
      animation: shimmer 3s;
      animation-iteration-count: infinite;
      background: linear-gradient(to right, #e6e6e6 5%, #cccccc 25%, #e6e6e6 35%);
      background-size: 1000px 100%;
    }

    @keyframes shimmer {
      from {
        background-position: -1000px 0;
      }
      to {
        background-position: 1000px 0;
      }
    }
  }

  &__button {
    margin: 40px auto 0;
    width: max-content;

    @include for-size(mobile) {
      margin: 32px auto 0;
    }

    ::v-deep > div {
      font-size: 20px;
      flex-direction: row-reverse !important;
      padding: 12px 4px;

      @include for-size(mobile) {
        font-size: 12px;
        padding: 0 2px;
      }

      img {
        padding-right: 0px !important;
        padding-left: 6px;
      }
    }
  }
}

::v-deep .slide-number{
  margin: 0 15px;

  @include for-size(mobile) {
    margin: 0 5%;
  }

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }
}

::v-deep .slide-item {
  margin: 0 15px;

  @include for-size(mobile) {
    margin: 0 5%;
  }

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }
}

::v-deep .body-slider__button {
  width: 44px;
  height: 44px;
}
</style>